import React, { useState } from "react";
import styles from "./AlumniFinancialGiving.module.css";
import CustomiseCta from "../CustomiseCta/CustomiseCta";
import AlumniFormPopup from "../AlumniFormPopup/AlumniFormPopup";

type FinancialGivingData = {
  id: number;
  title: string;
  description: string;
  cta_label: string;
  register_as_alumni?: any;
  heading_bullet_pts: string | null;
};

type AlumniFinancialGivingProps = {
  data: FinancialGivingData;
};

const AlumniFinancialGiving: React.FC<AlumniFinancialGivingProps> = ({
  data,
}) => {
  const { title, description, cta_label, register_as_alumni } = data;
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const openPopup = () => setIsPopupVisible(true);
  const closePopup = () => setIsPopupVisible(false);

  return (
    <div className="container" id="AlumniGive">
      <AlumniFormPopup
        show={isPopupVisible}
        onHide={closePopup}
        data={register_as_alumni}
      />
      <section className={styles.financialGivingSection}>
        <div className={styles.container}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>

          <strong className={styles.ctaLabel}>{cta_label}</strong>

          {register_as_alumni?.cta?.type === "pop-up" ? (
            <div className={styles.ctaButton}>
              <div className="d-none d-md-block">
                <button
                  style={{
                    backgroundColor:
                      register_as_alumni?.cta?.button?.button_color ||
                      undefined,
                    color:
                      register_as_alumni?.cta?.button?.text_color || undefined,
                  }}
                  onClick={openPopup}
                  data-interaction={
                    register_as_alumni?.cta?.button?.desktop_label
                  }
                >
                  {register_as_alumni?.cta?.button?.desktop_label}
                </button>
              </div>
              <div className="d-block d-md-none">
                <button
                  style={{
                    backgroundColor:
                      register_as_alumni?.cta?.button?.button_color ||
                      undefined,
                    color:
                      register_as_alumni?.cta?.button?.text_color || undefined,
                  }}
                  onClick={openPopup}
                  data-interaction={
                    register_as_alumni?.cta?.button?.mobile_label ||
                    register_as_alumni?.cta?.button?.desktop_label
                  }
                >
                  {register_as_alumni?.cta?.button?.mobile_label ||
                    register_as_alumni?.cta?.button?.desktop_label}
                </button>
              </div>
            </div>
          ) : (
            <div className={styles.ctaButton}>
              <CustomiseCta ctaData={register_as_alumni?.cta} />
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default AlumniFinancialGiving;
